<template>

  <div>

    <WizardPreferences
      v-if="preferencesDrawerVisible"></WizardPreferences>

  </div>

</template>

<script>
import WizardPreferences from '@/components/layout/drawers/Wizard.Preferences';
import GeneralFilters from '@/components/layout/drawers/General.Filters';

export default {

  name: 'AppDrawer',

  components: {
    WizardPreferences,
    GeneralFilters,
  },

  data() {
    return {
      tab: null,
    };
  },

  computed: {

    preferencesDrawerVisible() {
      if (this.$route.name) {
        const isWizardName = this.$route.name.toLowerCase().includes('wizard');
        // const isWizardPath = this.$route.path.toLowerCase().includes('wizard');
        const queryParamOverride = this.$route.query.drawer
          ? JSON.parse(this.$route.query.drawer)
          : false;

        // return isWizardName || isWizardPath || queryParamOverride;

        return true;
        // return isWizardName || queryParamOverride;
      }
      return false;
    },

  },

};
</script>
